module.exports = __webpack_public_path__ + "img/fushimi-HP-back001.3647a281.jpg";